import matchState from '@/common/utils/match';
import type { CalculationState } from '@/features/execute-calculation-set/overmind/calculation/createCalculationState';
import type { Context } from '@/overmind';

export type ISaveCalculationSetExecutionReport = {
  save: () => void;
};

type IInitializeCalculationSetExecutionReporting = {
  initialize: (
    getFailedCalculationSetExecution: () => CalculationState['calculationTactic'],
    getCalculationContext: () => CalculationState['calculationContext'],
    sharing: Context['effects']['sharing'],
    files: Context['effects']['files']
  ) => void;
};

let _getFailedCalculationSetExecution:
  | null
  | (() => CalculationState['calculationTactic']) = null;
let _getCalculationContext:
  | null
  | (() => CalculationState['calculationContext']) = null;
let _sharing: null | Context['effects']['sharing'] = null;
let _files: null | Context['effects']['files'] = null;
export const calculationSetExecutionReport: ISaveCalculationSetExecutionReport &
  IInitializeCalculationSetExecutionReporting = {
  initialize(
    getFailedCalculationSetExecution,
    getCalculationContext,
    sharing,
    files
  ) {
    _getFailedCalculationSetExecution = getFailedCalculationSetExecution;
    _getCalculationContext = getCalculationContext;
    _sharing = sharing;
    _files = files;
  },
  save() {
    if (
      !_getCalculationContext ||
      !_getFailedCalculationSetExecution ||
      !_sharing ||
      !_files
    ) {
      throw Error('[effect: errorReport]: not initialized!');
    }

    const calculationSetExecutionResult = _getFailedCalculationSetExecution();
    if (
      calculationSetExecutionResult.current === 'LOADING' ||
      calculationSetExecutionResult.current === 'NOT_LOADED'
    )
      return Promise.resolve();
    const calculationContext = _getCalculationContext();
    if (calculationContext.type === 'NOT_AVAILABLE') return Promise.resolve();

    const sharedCalculationSetExecutionUrl =
      _sharing.toCalculationSetExecutionUrl(
        calculationContext.calculationContext
      );
    const errorReport = {
      calculationSetExecutionUrl: sharedCalculationSetExecutionUrl,
      response: matchState(calculationSetExecutionResult, {
        ERROR: state => state.error,
        LOADED: calculationSetExecution => calculationSetExecution.value
      })
    };
    _files.save('calculation-set-execution-report', errorReport);
  }
};
